import { webMediaAdapter as e } from "./webMediaAdapter.mjs";
import { createContext as t, useContext as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/media/MediaAdapterContext.tsx
var i = t(e), a = ({ adapter: e, children: t }) => /* @__PURE__ */ r(i.Provider, {
	value: e,
	children: t
}), o = () => n(i);
//#endregion
export { a as MediaAdapterProvider, o as useMediaAdapter };
